import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import useStyles from './styles';
import {Avatar, Card, CardContent, Grid, Typography} from '@mui/material';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import {Link} from 'react-router-dom';

const TotalVDRs = props => {
  const { className, metrics, ...rest } = props;
  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              TOTAL VIRTUAL DATA ROOMS
            </Typography>
            <Typography
              variant="h3"
              className={classes.valueText}
            >{metrics.vdrCount}
            </Typography>
          </Grid>
          <Grid item>
            <Link to={'/documents/virtualrooms'}>
            <Avatar className={classes.avatar}>
              <MeetingRoomIcon className={classes.icon} />
            </Avatar>
            </Link>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

TotalVDRs.propTypes = {
  className: PropTypes.string
};

export default TotalVDRs;
